import FilterForm from '@/js/components/forms/filter_form';

class News {
  constructor() {
    this.dom = {
      filterForm: document.getElementById('filter-form'),
    };

    this.components = {
      filterForm: null,
    };

    this.mount();
  }

  mount() {
    if (this.dom.filterForm) {
      this.components.filterForm = new FilterForm(this.dom.filterForm);
    }
  }
}

if (document.getElementById('page-news-overview')) {
  // eslint-disable-next-line no-new
  new News();
}
